import { defineMessages } from 'react-intl';

export const vouchersMessages = defineMessages({
    issuedAt: {
        id: 'issued-at',
        defaultMessage: 'Issued at',
    },
    expiresAt: {
        id: 'expires-at',
        defaultMessage: 'Expires at',
    },
    isUsed: {
        id: 'is-used',
        defaultMessage: 'Is used',
    },
    remainingAmount: {
        id: 'remaining-amount',
        defaultMessage: 'Remaining amount',
    },
    issuedBy: {
        id: 'issued-by',
        defaultMessage: 'Issued by',
    },
    createVoucherSuccess: {
        id: 'create-voucher-success',
        defaultMessage: 'Voucher created',
    },
    createVoucherSuccessDescription: {
        id: 'create-voucher-success-description',
        defaultMessage: 'The voucher has been successfully created.',
    },
    addVoucherSubtitle: {
        id: 'add-voucher-subtitle',
        defaultMessage: 'Create a new voucher',
    },
    editVoucherSubtitle: {
        id: 'edit-voucher-subtitle',
        defaultMessage: 'Edit voucher',
    },
    updateVoucherSuccess: {
        id: 'update-voucher-success',
        defaultMessage: 'Voucher updated',
    },
    updateVoucherSuccessDescription: {
        id: 'update-voucher-success-description',
        defaultMessage: 'The voucher has been successfully updated.',
    },
    deleteVoucher: {
        id: 'delete-voucher',
        defaultMessage: 'Delete voucher',
    },
    deleteVoucherSuccess: {
        id: 'delete-voucher-success',
        defaultMessage: 'Voucher deleted',
    },
    deleteVoucherSuccessDescription: {
        id: 'delete-voucher-success-description',
        defaultMessage: 'The voucher has been successfully deleted.',
    },
    confirmDeleteVoucher: {
        id: 'confirm-delete-voucher',
        defaultMessage: 'Are you sure you want to delete this voucher? This action cannot be undone.',
    },
    deleteVoucherSubtitle: {
        id: 'delete-voucher-subtitle',
        defaultMessage: 'Permanently delete voucher',
    },
    voucherDashboard: {
        id: 'voucher-dashboard',
        defaultMessage: 'Voucher dashboard',
    },
    backToAllVouchers: {
        id: 'back-to-all-vouchers',
        defaultMessage: 'Back to all vouchers',
    },
    usedAmount: {
        id: 'used-amount',
        defaultMessage: 'Used amount',
    },
    vouchersBadge: {
        id: 'vouchers-badge',
        defaultMessage: 'Vouchers',
    },
    maxCountReachedError: {
        id: 'custom-error:voucher_type_max_count_reached_error',
        defaultMessage: 'Cannot create voucher because the maximum number of vouchers for this type has been reached!',
    },
    inactiveVoucherError: {
        id: 'custom-error:inactive_voucher_type_error',
        defaultMessage: 'The voucher cannot be created because the chosen voucher type is inactive!',
    },
});
